import { list_url } from "@project/sharedcomponents/apiURL"
import { getAxiosCancelToken, getCatchErrorMessage, isblank, setAxiosCancelToken } from "@project/sharedcomponents/utilityFunctions"
import axios from "axios"
import { getheaders, handleResponse, postErrorOnException } from "../Lib/commonfunctions"
import { LOADING_STATE, PARTYPRICE_SERVICE_CLEAR, PARTYPRICE_SERVICE_FAIL, PARTYPRICE_SERVICE_START, PARTYPRICE_SERVICE_SUCCESS, SNACKBAR_STATE } from "./types"

export const partyprice_data_clear = () => {
  return (dispatch) => {
    dispatch({
      type: PARTYPRICE_SERVICE_CLEAR,
    })
  }
}

export const fetch_partyprice_data = ({ dispatch, code, productgroupSelectedValue, productSubgroupSelectedValue, productSubgroupLevel2SelectedValue, itemSelectedValue, functions }) => {
  return (dispatch) => {
    if (typeof getAxiosCancelToken() != typeof undefined) {
      getAxiosCancelToken().cancel("Operation canceled due to new request.")
    }
    // save the new request for cancellation
    setAxiosCancelToken(axios.CancelToken.source())
    dispatch({ type: PARTYPRICE_SERVICE_START })
    dispatch({ type: LOADING_STATE, state: true })

    let data = new FormData()

    data.append("type", "partyprice")
    data.append("code", code)

    if (!isblank(productgroupSelectedValue)) {
      data.append("productgroupSelectedValue", productgroupSelectedValue)
    }

    if (!isblank(productSubgroupSelectedValue)) {
      data.append("productSubgroupSelectedValue", productSubgroupSelectedValue)
    }
    if (!isblank(productSubgroupLevel2SelectedValue)) {
      data.append("productSubgroupLevel2SelectedValue", productSubgroupLevel2SelectedValue)
    }
    if (!isblank(itemSelectedValue)) {
      data.append("itemSelectedValue", itemSelectedValue)
    }

    axios.defaults.headers.common = getheaders()
    axios({
      method: "post",
      url: list_url({ type: "partyprice" }),
      headers: { "Content-Type": "application/x-www-form-urlencoded" },

      data: data,
      cancelToken: getAxiosCancelToken().token,
    })
      .then((response) => handleResponse(response, dispatch))
      .then((response) => {
        if (response.data.meta.code === 401) {
          partypriceServiceFail({
            dispatch,
            response: response.data.meta.message,
            code,
            productgroupSelectedValue,
            productSubgroupSelectedValue,
            productSubgroupLevel2SelectedValue,
            itemSelectedValue,
          })
          dispatch({ type: LOADING_STATE, state: false })
        } else {
          partypriceServiceSuccess({ dispatch, user: response, code, productgroupSelectedValue, productSubgroupSelectedValue, productSubgroupLevel2SelectedValue, itemSelectedValue })
          dispatch({ type: LOADING_STATE, state: false })
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          dispatch({ type: LOADING_STATE, state: false })
        } else {
          postErrorOnException(error)
          partypriceServiceFail({
            dispatch,
            response: getCatchErrorMessage(error),
            code,
            productgroupSelectedValue,
            productSubgroupSelectedValue,
            productSubgroupLevel2SelectedValue,
            itemSelectedValue,
          })
          dispatch({ type: LOADING_STATE, state: false })
        }
      })
  }
}

const partypriceServiceSuccess = ({ dispatch, user, code, productgroupSelectedValue, productSubgroupSelectedValue, productSubgroupLevel2SelectedValue, itemSelectedValue }) => {
  dispatch({
    type: PARTYPRICE_SERVICE_SUCCESS,
    payload: user,
    code: code,
    productgroupSelectedValue,
    productSubgroupSelectedValue,
    productSubgroupLevel2SelectedValue,
    itemSelectedValue,
  })
}

const partypriceServiceFail = ({ dispatch, response, code, productgroupSelectedValue, productSubgroupSelectedValue, productSubgroupLevel2SelectedValue, itemSelectedValue }) => {
  dispatch({
    type: SNACKBAR_STATE,
    payload: true,
    message: response,
    snackbarType: "error",
  })

  dispatch({
    type: PARTYPRICE_SERVICE_FAIL,
    payload: response,
    code: code,
    productgroupSelectedValue,
    productSubgroupSelectedValue,
    productSubgroupLevel2SelectedValue,
    itemSelectedValue,
  })
}
